import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c408ef02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "report-header" }
const _hoisted_4 = { class: "createTime" }
const _hoisted_5 = { class: "box mark" }
const _hoisted_6 = { class: "report-card" }
const _hoisted_7 = { class: "target-block" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "target-label" }, "目标", -1))
const _hoisted_9 = { class: "target-value" }
const _hoisted_10 = { class: "section" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "< 当日数据 >", -1))
const _hoisted_12 = {
  key: 0,
  class: "report-table"
}
const _hoisted_13 = { class: "col-name" }
const _hoisted_14 = { class: "col-value" }
const _hoisted_15 = { class: "section" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "< 430到达数据 >", -1))
const _hoisted_17 = {
  key: 0,
  class: "report-table"
}
const _hoisted_18 = { class: "col-name" }
const _hoisted_19 = { class: "col-value" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))

import { ref, watch, onMounted, nextTick, computed } from "vue";
import { useRoute } from "vue-router";
import { formatPercentage, formatThousands, numToMoney } from "@/utils";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  Collapse,
  CollapseItem,
  Icon,
  showFailToast,
} from "vant";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";
import request from "@/provide/fetch";


export default /*#__PURE__*/_defineComponent({
  __name: 'VerticalMarket2026wmbt',
  setup(__props) {

const route = useRoute();
const visible = ref(false);
const pageData = ref<{
  gwtxTarget?: number;
  dayList?: any[];
  monthList?: any[];
}>({
  gwtxTarget: 0,
  dayList: [],
  monthList: [],
});
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");

const getPageList = async () => {
  try {
    const res = await request({
      url: "/api/wx/cs/battle-331-gwtx",
      method: "POST",
      data: {
        startDay: time,
        endDay: time,
      },
      headers: {
        openId: sessionStorage.getItem("openid"),
        // openId: "o7Gwj6a77l9SddB7PCU8-LNnbTtg",
      },
    });
    visible.value = true;
    if (res?.code === 200 && res?.data != null) {
      const data = res.data as {
        gwtxTarget?: number;
        dayList?: any[];
        monthList?: any[];
      };
      pageData.value = {
        gwtxTarget: data.gwtxTarget ?? 0,
        dayList: Array.isArray(data.dayList) ? data.dayList : [],
        monthList: Array.isArray(data.monthList) ? data.monthList : [],
      };
    } else {
      const msg =
        typeof res?.data === "string"
          ? res.data
          : res?.message ?? "加载失败，请稍后重试";
      showFailToast(msg);
    }
  } catch (_e) {
    visible.value = true;
    showFailToast("加载失败，请稍后重试");
  }
};
getPageList();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, " 生成时间：" + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(formatThousands)(pageData.value.gwtxTarget ?? 0)), 1)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            (pageData.value.dayList?.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_12, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.dayList, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", _hoisted_13, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatThousands)(item.value)), 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!pageData.value.dayList?.length)
              ? (_openBlock(), _createBlock(_unref(Empty), {
                  key: 1,
                  description: "暂无数据",
                  "image-size": "80"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            (pageData.value.monthList?.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value.monthList, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id,
                        class: _normalizeClass({ 'row-highlight': item.name === '累计达成进度' })
                      }, [
                        _createElementVNode("td", _hoisted_18, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(item.name === "累计达成进度"
                        ? _unref(formatPercentage)(item.value)
                        : _unref(formatThousands)(item.value)), 1)
                      ], 2))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!pageData.value.monthList?.length)
              ? (_openBlock(), _createBlock(_unref(Empty), {
                  key: 1,
                  description: "暂无数据",
                  "image-size": "80"
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_20
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})